module.exports = __webpack_public_path__ + "img/PLAY 2.87652200.png";